import { useState, useEffect } from 'react';
import { Sheet, Field, Select, PrimaryBtn, GhostBtn, IconBtn, Icons } from './UI';
import { today, fmtDate } from '../utils/constants';
import { api } from '../utils/api';
import { TaskForm } from './TaskForm';

function TodayForm({ tasks, onSave, onClose }) {
  const [taskId, setTaskId] = useState('');
  const [custom, setCustom] = useState('');
  const [saving, setSaving] = useState(false);

  const activeTasks = [...(tasks || [])].filter(t => t.status !== 'Complete').sort((a, b) => a.title.localeCompare(b.title));

  const [note, setNote] = useState('');

  const handleSave = async () => {
    if (!taskId && !custom.trim()) { alert('Pick a task or type a custom item.'); return; }
    setSaving(true);
    await onSave(taskId ? parseInt(taskId) : null, custom.trim(), note.trim());
    setSaving(false);
  };

  return (
    <Sheet title="Add to Today" onClose={onClose} footer={<><GhostBtn onClick={onClose}>Cancel</GhostBtn><PrimaryBtn onClick={handleSave} disabled={saving}>{saving ? 'Adding...' : 'Add to Today'}</PrimaryBtn></>}>
      <Field label="Pick an existing task">
        <Select value={taskId} onChange={e => setTaskId(e.target.value)}>
          <option value="">— Select a task —</option>
          {activeTasks.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
        </Select>
      </Field>
      <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '4px 0' }}>— or —</div>
      <Field label="Quick custom item">
        <input value={custom} onChange={e => setCustom(e.target.value)} placeholder="e.g. Call vendor about order..." style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', fontSize: 14, color: '#0f172a', outline: 'none', width: '100%', fontFamily: 'inherit', boxSizing: 'border-box' }} />
      </Field>
      <Field label="Today's Focus Note (optional)">
        <textarea value={note} onChange={e => setNote(e.target.value)} rows={3} placeholder="Which part of this are you tackling today?" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', fontSize: 14, color: '#0f172a', outline: 'none', width: '100%', fontFamily: 'inherit', resize: 'vertical', boxSizing: 'border-box' }} />
      </Field>
    </Sheet>
  );
}

function TodayItemDetail({ item, task, onToggle, onOpenTask, onClose }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 100 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: '#fff', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 640, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 16px 12px', borderBottom: '1px solid #f1f5f9' }}>
          <span style={{ fontSize: 16, fontWeight: 700 }}>Today Focus</span>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: 20, color: '#64748b' }}>×</button>
        </div>
        <div style={{ overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* Task title or custom text */}
          <div style={{ fontSize: 16, fontWeight: 600, color: '#0f172a', lineHeight: 1.4 }}>
            {task ? task.title : item.customText}
          </div>
          {/* Focus note */}
          {item.note && (
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 6 }}>Your Focus Note</div>
              <div style={{ fontSize: 14, color: '#334155', lineHeight: 1.6, background: '#f1f5f9', padding: '10px 12px', borderRadius: 8, borderLeft: '3px solid #3b82f6' }}>{item.note}</div>
            </div>
          )}
          {/* Task status if linked */}
          {task && (
            <div style={{ fontSize: 13, color: '#64748b' }}>
              Status: <span style={{ fontWeight: 600, color: '#0f172a' }}>{task.status}</span>
              {' · '}Priority: <span style={{ fontWeight: 600, color: '#0f172a' }}>{task.priority}</span>
            </div>
          )}
          {/* Worked on toggle */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: item.checked ? '#f0fdf4' : '#f8fafc', border: `1px solid ${item.checked ? '#86efac' : '#e2e8f0'}`, borderRadius: 8, padding: '10px 12px', cursor: 'pointer' }} onClick={onToggle}>
            <div style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.checked ? '#3b82f6' : '#e2e8f0'}`, background: item.checked ? '#3b82f6' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {item.checked && <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={2.5} width={13} height={13}><polyline points="20 6 9 17 4 12" /></svg>}
            </div>
            <span style={{ fontSize: 14, fontWeight: 600, color: item.checked ? '#16a34a' : '#475569' }}>{item.checked ? 'Marked as worked on' : 'Mark as worked on'}</span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, padding: '12px 16px', borderTop: '1px solid #f1f5f9' }}>
          <button onClick={onClose} style={{ background: '#f1f5f9', border: 'none', color: '#475569', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Close</button>
          {task && (
            <button onClick={() => onOpenTask(task.id)} style={{ background: '#3b82f6', border: 'none', color: '#fff', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 14, flex: 1 }}>Open Full Task →</button>
          )}
        </div>
      </div>
    </div>
  );
}

export function TodayTab({ store, setStore, currentUser, newActionRef }) {
  const [showForm, setShowForm] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => { if (newActionRef) newActionRef.current = { task: () => setShowForm(true) }; }, [newActionRef]);

  const items = (store.todayItems || []);
  const d = new Date();
  const dayLabel = d.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });

  const unchecked = items.filter(i => !i.checked);
  const checked = items.filter(i => i.checked);
  const sorted = [...unchecked, ...checked];

  const addItem = async (taskId, customText, note) => {
    const newItem = {
      id: store.todayNextId || 1,
      person: currentUser || '',
      date: today(),
      taskId: taskId || null,
      customText: customText || '',
      note: note || '',
      checked: false,
      sortOrder: store.todayNextId || 1,
    };
    setStore(s => ({ ...s, todayNextId: (s.todayNextId || 1) + 1, todayItems: [...(s.todayItems || []), newItem] }));
    setShowForm(false);
    await api.saveTodayItem(newItem);
  };

  const openItem = (id) => {
    const item = items.find(i => i.id === id);
    if (item) setSelectedItem(item);
  };

  const toggleChecked = (id) => {
    const item = items.find(i => i.id === id);
    if (!item) return;
    const updated = { ...item, checked: !item.checked };
    setStore(s => ({ ...s, todayItems: s.todayItems.map(i => i.id === id ? updated : i) }));
    api.saveTodayItem(updated);
    if (selectedItem && selectedItem.id === id) setSelectedItem(updated);
  };

  const openTaskEdit = (taskId) => {
    const task = (store.tasks || []).find(t => t.id === taskId);
    if (task) { setSelectedItem(null); setEditingTask(task); }
  };

  const removeItem = async (id) => {
    if (!window.confirm("Remove from today's list?")) return;
    setStore(s => ({ ...s, todayItems: s.todayItems.filter(i => i.id !== id) }));
    await api.deleteTodayItem(id);
  };

  const saveEditedTask = async (task) => {
    const saved = { ...task, dateUpdated: new Date().toISOString().slice(0, 16) };
    setStore(s => ({ ...s, tasks: s.tasks.map(t => t.id === saved.id ? saved : t) }));
    setEditingTask(null);
    await api.saveTask(saved);
  };

  return (
    <>
      <div style={{ paddingBottom: 80 }}>
        <div style={{ fontSize: 13, color: '#64748b', paddingBottom: 12, fontWeight: 500 }}>
          {dayLabel} · {currentUser || 'My'} Focus
        </div>

        {sorted.length === 0 && (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: '48px 20px' }}>
            Nothing on your list yet.<br />
            <span style={{ fontSize: 13 }}>Use "+ Add to Today" to build your focus list for today.</span>
          </div>
        )}

        {sorted.map(item => {
          const task = item.taskId ? (store.tasks || []).find(t => t.id === item.taskId) : null;
          const label = task ? task.title : item.customText;
          const isCustom = !item.taskId;
          const isCarriedOver = item.date !== today();

          return (
            <div
              key={item.id}
              onClick={() => openItem(item.id)}
              style={{ background: '#fff', borderRadius: 10, padding: '12px 14px', marginBottom: 8, cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,.06)', display: 'flex', alignItems: 'flex-start', gap: 12, opacity: item.checked ? 0.6 : 1 }}
            >
              {/* Checkbox */}
              <div style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.checked ? '#3b82f6' : '#e2e8f0'}`, background: item.checked ? '#3b82f6' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                {item.checked && <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={2.5} width={13} height={13}><polyline points="20 6 9 17 4 12" /></svg>}
              </div>

              {/* Content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: item.checked ? '#94a3b8' : '#0f172a', textDecoration: item.checked ? 'line-through' : 'none', lineHeight: 1.4 }}>
                  {label}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
                  {isCustom && <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 7px', borderRadius: 10, background: '#f0fdf4', color: '#16a34a' }}>Quick item</span>}
                  {!isCustom && task && <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 7px', borderRadius: 10, background: '#eff6ff', color: '#3b82f6' }}>Task</span>}
                  {isCarriedOver && <span style={{ fontSize: 11, color: '#f59e0b' }}>↩ from {fmtDate(item.date)}</span>}
                </div>
                {item.note && (
                  <div style={{ fontSize: 13, color: '#475569', marginTop: 6, padding: '6px 10px', background: '#f1f5f9', borderRadius: 6, borderLeft: '3px solid #3b82f6', lineHeight: 1.4 }}>
                    {item.note}
                  </div>
                )}
              </div>

              {/* Remove */}
              <div onClick={e => e.stopPropagation()}>
                <IconBtn onClick={() => removeItem(item.id)} title="Remove" color="#ef4444"><Icons.X /></IconBtn>
              </div>
            </div>
          );
        })}
      </div>

      {showForm && <TodayForm tasks={store.tasks} onSave={addItem} onClose={() => setShowForm(false)} />}
      {editingTask && <TaskForm initial={editingTask} currentUser={currentUser} onSave={saveEditedTask} onClose={() => setEditingTask(null)} />}
      {selectedItem && (
        <TodayItemDetail
          item={selectedItem}
          task={selectedItem.taskId ? (store.tasks || []).find(t => t.id === selectedItem.taskId) : null}
          onToggle={() => toggleChecked(selectedItem.id)}
          onOpenTask={openTaskEdit}
          onClose={() => setSelectedItem(null)}
        />
      )}
    </>
  );
}

